import { Component } from '@angular/core';
import { ToolInfoBoxService } from '../../../services/Tool-Info-Box.service';

@Component({
  selector: 'tool-street-info-box',
  templateUrl: './tool-street-info-box.component.html',
  styleUrls: ['./tool-street-info-box.component.css']
})
export class ToolStreetInfoBoxComponent {

  constructor(public toolInfoBoxService: ToolInfoBoxService) {}

  onClickIntersect(){
    this.toolInfoBoxService.isInfoBoxActive = !this.toolInfoBoxService.isInfoBoxActive;
  }

}
